import React from "react";

const VatCycle = () => {
  return (
    <section className="py-20 md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-[2.25rem] text-text-primary mb-5">
            Start with your next VAT cycle.
          </h2>
          <p className="text-lg md:text-xl text-text-secondary">
            Try Repayas free for 14 days. See your Safe-to-Spend before you
            commit.
          </p>
        </div>
        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-2xl border border-[#E8E6E3] p-8 md:p-10">
            <div className="text-center mb-8">
              <p className="text-sm font-medium text-[#6B6B6B] mb-2">
                Everything you need
              </p>
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-4xl md:text-5xl font-semibold text-text-primary">
                  £29
                </span>
                <span className="text-text-secondary">/month</span>
              </div>
              <p className="text-sm text-500 mt-2">after 14-day free trial</p>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center gap-3">
                <svg
                  className="h-5 w-5 text-primary shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span className="text-base text-text-primary">
                  14-day free trial
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="h-5 w-5 text-primary shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span className="text-base text-text-secondary">
                  No card required
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="h-5 w-5 text-primary shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span className="text-base text-[#0F0F0F]">
                  Open Banking connection
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="h-5 w-5 text-primary shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span className="text-base text-text-primary">
                  Safe-to-Spend dashboard
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="h-5 w-5 text-primary shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span className="text-base text-primary">
                  Friday SMS summary
                </span>
              </li>
            </ul>
            <a
              className="flex w-full h-12 items-center justify-center rounded-lg bg-primary text-base font-semibold text-white  hover:brightness-95 hover:ring-4  transition-all hover:ring-ring"
              href="/onboarding/profile"
            >
              Start free trial
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VatCycle;
